import { StatusConfirmationCode } from "~/typings/types";

export const KEY_CUSTOMER_CLIENT_ID = "clientId";
export const KEY_CUSTOMER_CLIENT_ID_V2 = "clientId_v2";
export const KEY_PARTNER_CLIENT_ID = "partnerClientId";
export const KEY_CLIENT_HASH = "hash";
export const BUTTON_NEXT_ID = "button_next_id";
export const BUTTON_BACK_ID = "button_back_id";
export const CLIENT_PROMOCODE = "client_promocode";
export const REFERRAL_PROMOCODE = "promocode_referral";
export const ERROR_FIELD_ = "error_field_";
export const INITIAL_REQUEST_CODE: StatusConfirmationCode = "initial-request-code";
export const PENDING_REQUEST_CODE: StatusConfirmationCode = "pending-request-code";
export const RESEND_REQUEST_CODE: StatusConfirmationCode = "resend-request-code";
export const SEND_WITHOUT_REQUEST_CODE: StatusConfirmationCode = "send-without-request-code";
export const ATTACHMENT_PAGE = "attachment-page";

export const ENV_IS_ENABLED_YANDEX_METRIKA = import.meta.env.VITE_FEATURE_FLAG_is_enabled_ymetrika;
export const ENV_IS_ENABLED_ROISTAT = import.meta.env.VITE_FEATURE_FLAG_is_enabled_roistat;
export const COUNTER_ID_YMETRIKA = import.meta.env.VITE_COUNTER_ID_YMETRIKA;
export const ENV_IS_ENABLED_SBERID = import.meta.env.VITE_FEATURE_FLAG_is_enabled_sberid === "true";

export const URL_OFERTA = "https://prodamus.ru/oferta";
export const URL_OFERTA_PARTNERS = "https://prodamus.ru/oferta/partners";
export const URL_PRIVACY = "https://prodamus.ru/privacy";
export const URL_TARIF = "https://prodamus.ru/rates";
export const URL_PROMO = "https://prodamus.ru/consenttomailings";

export const ENV_MODE_SELF_EMPLOYED = import.meta.env.VITE_FEATURE_FLAG_mode_self_employed;
